// @ts-check
import { computed } from 'vue';
import { useGetters } from 'vuex-composition-helpers/dist';
import { useUserRole } from '@/composables/user';
import { usePlans } from '@/composables/plans';

export function useTeamsUpsell() {
  const { totalTeams } = useGetters({
    totalTeams: 'groups/totalCount',
  });

  return {
    canUpgrade: useUserRole().isSuperAdmin,
    canAccess: usePlans().hasTeamsAccess,
    /**
     * @returns {import('vue').ComputedRef<boolean>}
     */
    // eslint-disable-next-line arrow-body-style
    hasTried: computed(() => {
      return totalTeams.value > 0;
    }),
  };
}
